import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import WorkCard from "@/components/base/WorkCard";
import { getFeaturedWorks } from "@/utils/content";

interface FeaturedWorksProps {
  type: "movie" | "series";
  eyebrow: string;
  title: string;
  subtitle: string;
}

export default function FeaturedWorks({ type, eyebrow, title, subtitle }: FeaturedWorksProps) {
  const all = getFeaturedWorks(type, 8);
  const [limit, setLimit] = useState(4);
  const list = all.slice(0, limit);

  return (
    <section className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        eyebrow={eyebrow}
        title={title}
        subtitle={subtitle}
        moreLink={`/category/${type}`}
        moreText={`全部${type === "movie" ? "电影" : "剧集"}`}
      />
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-6">
        {list.map((work) => (
          <WorkCard key={work.id} work={work} showHeat />
        ))}
      </div>
      {limit < all.length && (
        <div className="mt-8 flex justify-center">
          <button
            type="button"
            onClick={() => setLimit((l) => Math.min(l + 4, all.length))}
            className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            加载更多
            <i className="ri-add-line ml-1" />
          </button>
        </div>
      )}
    </section>
  );
}